
@if (field()) {
  <div class="checkbox-field__container">
    @if(field().title) {
      <h2 class="ci-heading-h6-semibold">
        {{ field().title }}
      </h2>
    }
    
    @if(field().description) {
      <p class="checkbox-field__description ci-caption-regular">
        {{ field().description }}
      </p>
    }
    
    @if( field().options && field().options.length > 0 ) {
      <ul class="checkbox-field__options">
        @for(option of field().options; track option) {
          <li class="checkbox-field__option">
            <ci-checkbox 
              class="option__checkbox"
              [attr.name]="'checkbox-' + option" 
              [attr.value]="option"
              [attr.required]="field().required"
              (change)="handleCheckboxChange($event)"
            >
              <span 
                slot="label-right"
                class="ci-paragraph-p1-regular"
              >
                {{ option }}
              </span>
            </ci-checkbox>
          </li>
        }
      </ul>
    }
    
    @if(field().required) {
      @if(showErrorMessage()) {
        <span class="checkbox-field__error-text ci-caption-regular">
          {{ 'Por favor, seleccione al menos una opción' | translate }}
        </span>
      } @else {
        <span class="checkbox-field__supporting-text ci-caption-regular">
          {{ 'Obligatorio' | translate }}
        </span>
      }
    }
  </div>
}

